import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogClose } from '@angular/material/dialog';
import { ButtonComponent } from '@libs/common/components';
import { NumberComponent } from '@libs/form/components';
import { AutocompleteInputModel, TextInputModel } from '@libs/form/models';
import { debounceTime, filter } from 'rxjs';
import { SearchSuggestionAutocompleteComponent } from '../../elements/search-suggestion-autocomplete';

@Component({
  selector: 'ui-add-to-shopping-list-quick',
  templateUrl: './add-to-shopping-list-quick.component.html',
  styleUrls: ['./add-to-shopping-list-quick.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    NumberComponent,
    FormsModule,
    MatDialogClose,
    SearchSuggestionAutocompleteComponent,
  ],
})
export class AddToShoppingListQuickComponent {
  public productSelected: OutputEmitterRef<[string, number]> = output();
  public isDialogView: InputSignal<boolean> = input(false);

  public searchControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });
  public quantityControl: FormControl<number> = new FormControl<number>(1, { nonNullable: true });

  public searchInputConfig: Signal<AutocompleteInputModel> = computed(() => {
    return {
      type: 'autocomplete',
      name: 'search',
      label: 'Name, Art.Nr., GTIN',
      hint: '*Pflichtfeld',
      allowArbitraryValue: true,
      hideSingleSelectionIndicator: true,
      attributes: {
        required: true,
        spellcheck: false,
      },
      options: [],
    };
  });

  public productQuantityInputConfig: Signal<TextInputModel> = computed(() => ({
    type: 'number',
    name: 'quantity',
    label: 'Anzahl',
    hint: '*Pflichtfeld',
    attributes: {
      required: true,
      spellcheck: false,
    },
  }));

  public constructor() {
    this.searchControl.valueChanges.pipe(
      takeUntilDestroyed(),
      debounceTime(300),
      filter(() => this.searchControl.valid),
    ).subscribe(() => {
      this.quantityControl.setValue(1);
    });
  }

  public addToShoppingList(): void {
    if (this.searchControl.value && this.quantityControl.value) {
      this.productSelected.emit([this.searchControl.value, this.quantityControl.value]);
    }
  }
}
